import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@mellify/ui';
import { ConnectChannelModal } from './channels/components/ConnectChannelModal';

export const ChannelsPageActions: React.FC = () => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="primary"
        size="md"
        leftIcon={<Plus className="w-4 h-4" />}
        onClick={() => setIsConnectModalOpen(true)}
      >
        Connect Channel
      </Button>

      <ConnectChannelModal
        isOpen={isConnectModalOpen}
        onClose={() => setIsConnectModalOpen(false)}
      />
    </>
  );
};

ChannelsPageActions.displayName = 'ChannelsPageActions';